__turbopack_context__.v({
  "className": "great_vibes_5b92a10a-module__HEAwMG__className",
});
